import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setInventoryitemFilterCriteria } from 'store/slice/ManufSlice';

export default function InventoryitemFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.inventoryitemDashboard);
        
    const {mfproductList} = useSelector((state)=>state.manufslice);
    
const updateProductnameCriteria = (productname) =>{
        dispatch(setInventoryitemFilterCriteria(
            {
                ...filterCriteria,
                productname:productname
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Productname"
                            name="productname"
                            value={filterCriteria.productname}
                            onChange={(e)=>updateProductnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}